import { CancelCompleteProps } from 'src/pages/CancelPage/CancelCompletePage/index'
import styled from 'styled-components'
import { Noto_body1_r16, Noto_heading3_b20 } from 'src/styles/fonts/NotoSansKrFonts'
import cancel_bye from 'src/assets/images/cancel/cancel_bye.png'
import Button, { ButtonOption1, ButtonOption2 } from 'src/components/common/Button'
import { Typography } from 'src/components/common/Typography'
import { Container } from 'src/components/common/Container'
import RenderIf from 'src/components/common/RenderIf'
import { useChannel } from 'src/provider/ChannelContextProvider'

const CancelCompletePageView = ({ introPageNav, appExit }: CancelCompleteProps) => {
  const { web } = useChannel()
  return (
    <S.CancelCompleteContainer $option="flex_column">
      <S.PrimaryImage src={cancel_bye} alt="서비스 해지 이미지" />
      <Typography $fontStyle={Noto_heading3_b20}>
        그동안 휴대폰쿠폰지갑 서비스를
        <br /> 이용해 주셔서 감사합니다.
      </Typography>
      <Typography $fontStyle={Noto_body1_r16} $color="var(--black-70)">
        보다 나은 서비스로 찾아오겠습니다.
      </Typography>
      <S.CancelCompleteButtonSection $option="flex_column" $row_gap="10px">
        <Button option={ButtonOption1('default')} onClickFn={introPageNav}>
          홈으로
        </Button>
        <RenderIf when={!web}>
          <Button option={ButtonOption2('default')} onClickFn={appExit}>
            앱종료
          </Button>
        </RenderIf>
      </S.CancelCompleteButtonSection>
    </S.CancelCompleteContainer>
  )
}
export default CancelCompletePageView

const S = {
  CancelCompleteContainer: styled(Container)`
    max-width: 320px;
    width: calc(100% - 40px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    gap: 20px;
    text-align: center;
  `,
  CancelCompleteButtonSection: styled(Container)`
    margin-top: 50px;
    padding: 0 30px;
  `,
  PrimaryImage: styled.img`
    margin: 0 auto;
    width: 150px;
  `,
}
